import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getData } from "../newApis/dotNetApiMethods";

type Tdata = {
  id: number;
  name: string;
  value: string;
};

const getLegalEntities = async () => {
  const data = await getData(ajaxEndpoints.LEGAL_ENTITIES);

  return data?.data?.data;
};

export default function useGetLegalEntities() {
  return useQuery<Tdata[]>("getLegalEntities", getLegalEntities, {
    refetchOnWindowFocus: false,
  });
}
